<template>
  <b-nav pills fill class="nav-bar">
    <b-navbar-brand href="/">
      <img class="mx-3" width="80" height="80" alt="Diablo II: Resurrected" src="../assets/D2TZ-logo.png">
    </b-navbar-brand>
    <b-nav-dropdown 
      class="mx-3 nav-item nav-tz-introduction"
      :text="$t('nav.introduction')"
      href="/introduction"
      :active="path==='/introduction'"
    >
      <b-dropdown-item href="/introduction">{{$t('blog.tzIntroduction')}}</b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item href="/blog?zones=chaos-sanctuary">{{$t('blog.chaosRun')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?zones=wsk">{{$t('blog.wskRun')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?zones=moo-moo-farm">{{$t('blog.moomooRun')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?zones=halls-of-the-dead">{{$t('blog.hallOfDeadRun')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?zones=stony-tomb">{{$t('blog.stonyTombRun')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?zones=pit">{{$t('blog.pitRun')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?zones=travincal">{{$t('blog.travincalRun')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?zones=flayer-jungle">{{$t('blog.flayerJungleRun')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?zones=arcane-sanctuary">{{$t('blog.arcaneSanctuaryRun')}}</b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item href="/blog?build=mosaic-asn">{{$t('blog.mosaicAsnBuild')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?build=hammerdin">{{$t('blog.hammerdinBuild')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?build=nova-sor">{{$t('blog.novaSorBuild')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?build=lightning-sor">{{$t('blog.lightningSorBuild')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?build=lightning-javazon">{{$t('blog.javazonBuild')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?build=summon-nec">{{$t('blog.summonNecBuild')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?build=bow-ama">{{$t('blog.bowzonBuild')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?build=fireclaws-dru">{{$t('blog.fireclawsDruBuild')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?build=berserker-barb">{{$t('blog.berserkerBarbBuild')}}</b-dropdown-item>
      <b-dropdown-item href="/blog?build=wind-dru">{{$t('blog.windDruBuild')}}</b-dropdown-item>
    </b-nav-dropdown>
    <b-nav-item class="mx-3 nav-item nav-tz" href="/online" :active="path==='/online'">
      {{ $t('mode.onlineTZ') }}
    </b-nav-item>
    <b-nav-item class="mx-3 nav-item nav-tz" href="/offline" :active="path==='/offline'">
      {{ $t('mode.offlineTZ') }}
    </b-nav-item>
    <b-nav-item class="mx-3 nav-item nav-tz" href="/apps" :active="path==='/apps'">
      {{ $t('nav.notificationApp') }}
    </b-nav-item>
    <b-nav-item class="mx-3 nav-item nav-tz" href="/exp" :active="path==='/exp'">
      {{ $t('nav.levelupCalculator') }}
    </b-nav-item>
    <b-nav-item-dropdown
      :text="$t('common.terrorZones')"
      class="mx-3 nav-tz-dropdown"
      right
    >
      <b-dropdown-item href="/online">{{ $t('mode.onlineTZ') }}</b-dropdown-item>
      <b-dropdown-item href="/offline">{{ $t('mode.offlineTZ') }}</b-dropdown-item>
      <b-dropdown-divider/>
      <b-dropdown-item href="/apps">{{ $t('nav.notificationApp') }}</b-dropdown-item>
      <b-dropdown-divider/>
      <b-dropdown-item href="/exp">{{ $t('nav.levelupCalculator') }}</b-dropdown-item>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown class="mx-3" right>
      <template #button-content>
        <b-icon icon="globe" aria-hidden="true"></b-icon>
        <span class='language-text'>En / 文</span>
      </template>
      <b-dropdown-item @click="changeLanguage('en-us')">English</b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('fr')">Français</b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('ko')">한국어</b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('zh-cn')">简体中文</b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('zh-tw')">繁體中文</b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('ja')">日本語</b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('ru')">Русский</b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('es')">Español</b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('de')">Deutsch</b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('it')">Italiano</b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('pt-br')">Português</b-dropdown-item>
      <b-dropdown-item @click="changeLanguage('pl')">Polski</b-dropdown-item>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown class="mx-3 nav-menu" right>
      <template #button-content>
        <b-icon icon="list-ul" aria-hidden="true"></b-icon>
      </template>
      <b-dropdown-item href="/introduction">{{ $t('nav.introduction') }}</b-dropdown-item>
      <b-dropdown-divider/>
      <b-dropdown-item href="/online">{{ $t('mode.onlineTZ') }}</b-dropdown-item>
      <b-dropdown-item href="/offline">{{ $t('mode.offlineTZ') }}</b-dropdown-item>
      <b-dropdown-divider/>
      <b-dropdown-item href="/apps">{{ $t('nav.notificationApp') }}</b-dropdown-item>
      <b-dropdown-divider/>
      <b-dropdown-item href="/exp">{{ $t('nav.levelupCalculator') }}</b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
export default {
  name: 'TerrorZoneNavBar',

  emits: ['change-language'],

  computed: {
    path () {
      return window.location.pathname;
    },
  },

  methods: {
    changeLanguage (language) {
      console.log('change language to: ' + language);
      localStorage.setItem('language', language);
      this.$i18n.locale = language;
      this.$emit('change-language', language);
    },
  }
}
</script>

<style scoped>
.nav-bar {
  background-color: #000;
  box-shadow: 0px 5px 10px #222;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  --bs-nav-pills-link-active-color: #000;
  --bs-nav-pills-link-active-bg: #fff;
  --bs-link-color: #aaa;
  --bs-nav-link-hover-color: #fff;
}
.nav-item {
  bottom: 0;
  font-weight: bold;
  z-index: 2000;
}
.nav-menu {
  display: none;
}
.nav-tz-introduction {
  display: block;
}
.nav-tz {
  display: block;
}
@media (max-width: 1500px) {
  .nav-tz {
    display: none;
  }
}
.nav-tz-dropdown {
  display: none;
}
@media (max-width: 1500px) {
  .nav-tz-dropdown {
    display: block;
  }
}
@media (max-width: 500px) {
  .nav-tz-introduction {
    display: none;
  }
  .nav-tz {
    display: none;
  }
  .nav-tz-dropdown {
    display: none;
  }
  .nav-menu {
    display: block;
  }
}
.language-text {
  display: inline-block;
  margin-left: 5px;
  margin-right: 2px;
  max-width: 75px;
}

@media (max-width: 800px) {
  .language-text {
    display: none;
  }
}
</style>
